import styled from 'styled-components';

export const EmojiWrapper = styled.div`
  display: flex;
  svg {
    height: 100px;
    width: 100px;
  }
`;
